var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M33.47 16.987a1.01 1.01 0 00.237 1.41L40.169 23H4a1 1 0 000 2h36.169l-6.462 4.604A1.01 1.01 0 0033.46 31a.978.978 0 001.373.242l9.023-6.428a1 1 0 000-1.628l-9.023-6.428a.978.978 0 00-1.364.229z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
